import React from 'react';
import { MusicIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section aria-labelledby="final-cta-title" className="bg-brand-navy px-4 py-24 text-center text-white" data-id="element-84" data-mp="3n4wbi69tcnm3">
      <Reveal className="mx-auto max-w-3xl" data-id="element-85" data-mp="vv1tvbr68l8">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-white/10 text-brand-gold" data-id="element-86" data-mp="ujzlzxyh8w8">
          <MusicIcon className="h-7 w-7" aria-hidden="true" data-id="element-87" data-mp="2zfbrrl5u5mbr" />
        </div>
        <h2 id="final-cta-title" className="mx-auto mt-6 max-w-2xl text-3xl font-extrabold tracking-tight md:text-5xl" data-id="element-88" data-mp="34dn0ttob3ssx">
          Prêt à faire vivre la musique dans votre classe&nbsp;?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-89" data-mp="3e3gauq8svzv2">
          Des ressources structurées pour préparer vos séances et accompagner vos élèves.
        </p>
        <CTAButton className="mt-9 w-full max-w-md focus-visible:ring-white focus-visible:ring-offset-brand-navy" data-id="element-90" data-mp="2llkf43wt5mbt" />
        <p className="mt-4 text-[11px] font-semibold text-white" data-id="element-91" data-mp="26tzbjwf1cj46">
          10 tomes <span className="px-1.5 text-brand-gold" data-id="element-92" data-mp="21w7i2xyqsoxv">·</span> 5 bonus
          <span className="px-1.5 text-brand-gold" data-id="element-93" data-mp="21y0rgl0qpn9k">·</span> En français
        </p>
      </Reveal>
    </section>;
}